import React from 'react';

import { ChildrenAndClassName } from 'common/types/react';

const BLUE = {
  mainColour: '#8CBAFF',
  shadows: '#5E9DFF',
};

const GREEN = {
  mainColour: '#D4EFD6',
  shadows: '#368637',
};

type NoEntitiesProps = {
  variant?: 'green' | 'blue';
} & ChildrenAndClassName;

export default React.memo(function NoEntitiesBanner({
  variant = 'green',
  ...otherProps
}: NoEntitiesProps) {
  const mainColour = variant === 'green' ? GREEN.mainColour : BLUE.mainColour;
  const shadowColour = variant === 'green' ? GREEN.shadows : BLUE.shadows;

  return (
    <svg
      viewBox="0 0 320 208"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path d="M60 107.5H69.5L64.5 126L60 125.5V107.5Z" fill={mainColour} />
      <path d="M95 107.5H104.5L99.5 126L95 125.5V107.5Z" fill={mainColour} />
      <path
        d="M94.375 100.563C96.5463 98.2494 101.5 99.2507 101.5 99.2507L96 104.251L92.25 102.126C92.25 102.126 93.202 101.813 94.375 100.563Z"
        fill={mainColour}
      />
      <path
        d="M59.0625 93.9375C62.5639 91.0596 68.75 84.375 68.75 84.375L66.5 91.625L62.125 97L56.375 94.375C56.375 94.375 57.7636 95.0051 59.0625 93.9375Z"
        fill={mainColour}
      />
      <path d="M233 89H247V126H233V89Z" fill={mainColour} />
      <path
        d="M268.281 23.375H276.875L275.859 30.8872H268.281V23.375Z"
        fill={mainColour}
      />
      <path d="M268.281 46H270V105H268.281V46Z" fill={mainColour} />
      <path
        d="M268 109.5L270.5 100H278C278 100 278.376 122.576 275.5 124.5C272.624 126.424 268 126 268 126V109.5Z"
        fill={mainColour}
      />
      <path d="M231 74H235V88H231V74Z" fill={mainColour} />
      <path d="M207.5 107.5L202.5 103H214V107.5H207.5Z" fill={mainColour} />
      <path
        d="M171.313 95.2498L167.313 93.3748L170.782 88.4863L173.811 92.8782L172.599 93.7364L171.313 95.2498Z"
        fill={mainColour}
      />
      <path d="M206 112L214.5 116.5L215 121.5L206 116.5V112Z" fill={mainColour} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M232.081 41.7273C234.754 41.2917 236.795 38.972 236.795 36.1758C236.795 33.0692 234.276 30.5508 231.17 30.5508C229.681 30.5508 228.327 31.1293 227.321 32.0739C227.617 32.0256 227.922 32.0004 228.232 32.0004C231.339 32.0004 233.857 34.5188 233.857 37.6254C233.857 39.243 233.174 40.7011 232.081 41.7273Z"
        fill={mainColour}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M228.403 35.5759C229.092 34.8684 229.517 33.9022 229.517 32.8368C229.517 30.6682 227.759 28.9102 225.59 28.9102C223.421 28.9102 221.663 30.6682 221.663 32.8368C221.663 32.9775 221.671 33.1165 221.685 33.2533C222.398 32.5207 223.395 32.0657 224.499 32.0657C226.527 32.0657 228.195 33.603 228.403 35.5759Z"
        fill={mainColour}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M227.775 32.2915C228.382 31.3934 228.737 30.3104 228.737 29.1445C228.737 26.0379 226.219 23.5195 223.112 23.5195C220.005 23.5195 217.487 26.0379 217.487 29.1445C217.487 29.5229 217.524 29.8926 217.596 30.25C218.607 28.7549 220.318 27.772 222.259 27.772C224.987 27.772 227.261 29.7143 227.775 32.2915Z"
        fill={mainColour}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M191.563 31.524C193.54 30.6518 194.92 28.6746 194.92 26.375C194.92 23.2684 192.401 20.75 189.295 20.75C187.198 20.75 185.369 21.8974 184.401 23.5987C185.095 23.2926 185.863 23.1226 186.67 23.1226C189.776 23.1226 192.295 25.641 192.295 28.7476C192.295 29.7573 192.029 30.7048 191.563 31.524Z"
        fill={mainColour}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M199.187 26.4375L193.375 25.5625L192.51 26.9465C193.967 27.963 194.92 29.6515 194.92 31.5625C194.92 32.7545 194.549 33.8599 193.916 34.7696C195.479 34.5151 195.967 33.552 196 33L197.687 30.0625L199.187 26.4375Z"
        fill={mainColour}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.3562 86.8018C91.0324 86.2023 91.5 84.9143 91.5 83.4221C91.5 81.9299 91.0324 80.6419 90.3562 80.0423C90.7139 79.8123 91.1139 79.6836 91.536 79.6836C93.0585 79.6836 94.2927 81.3574 94.2927 83.4221C94.2927 85.4868 93.0585 87.1605 91.536 87.1605C91.1139 87.1605 90.7139 87.0318 90.3562 86.8018Z"
        fill={mainColour}
      />
      <path
        d="M124.693 96.4787C124.693 98.126 123.357 99.4614 121.71 99.4614V93.4961C123.357 93.4961 124.693 94.8315 124.693 96.4787Z"
        fill={mainColour}
      />
      <path
        d="M128.104 103.141C128.104 104.788 126.769 106.124 125.121 106.124V100.158C126.769 100.158 128.104 101.494 128.104 103.141Z"
        fill={mainColour}
      />
      <path
        d="M137.876 114.197C137.876 115.845 136.541 117.18 134.894 117.18V111.215C136.541 111.215 137.876 112.55 137.876 114.197Z"
        fill={mainColour}
      />
      <rect x="0.647705" y="125.344" width="318.602" height="2" fill={shadowColour} />
      <rect
        opacity="0.3"
        x="45.5266"
        y="142.018"
        width="230.321"
        height="2"
        fill={shadowColour}
      />
      <rect
        opacity="0.24"
        x="79.4843"
        y="158.258"
        width="162.406"
        height="2"
        fill={shadowColour}
      />
      <rect
        opacity="0.2"
        x="110.489"
        y="174.5"
        width="100.396"
        height="2"
        fill={shadowColour}
      />
      <rect
        opacity="0.1"
        x="140.017"
        y="190.74"
        width="41.3396"
        height="2"
        fill={shadowColour}
      />
      <circle cx="153.305" cy="183.357" r="1.47642" fill={shadowColour} />
      <circle cx="126.462" cy="185.357" r="1.47642" fill={shadowColour} />
      <circle cx="57.8203" cy="149.4" r="2.95283" fill={shadowColour} />
      <circle cx="227.149" cy="149.424" r="1.5" fill={shadowColour} />
      <circle cx="188.739" cy="184.834" r="1.47642" fill={shadowColour} />
      <circle cx="123.777" cy="149.4" r="1.47642" fill={shadowColour} />
      <circle cx="213.838" cy="167.117" r="2.95283" fill={shadowColour} />
      <circle cx="247.796" cy="152.353" r="2.95283" fill={shadowColour} />
      <circle cx="188.763" cy="136.137" r="1.5" fill={shadowColour} />
      <circle cx="119.347" cy="133.16" r="2.95283" fill={shadowColour} />
      <circle cx="193.168" cy="168.593" r="2.95283" fill={shadowColour} />
      <circle cx="138.564" cy="162.711" r="1.5" fill={shadowColour} />
      <circle cx="89.8428" cy="168.617" r="1.5" fill={shadowColour} />
      <circle cx="98.2012" cy="150.924" r="2.95283" fill={shadowColour} />
      <circle cx="69.1493" cy="153.83" r="1.47642" fill={shadowColour} />
      <circle cx="86.8663" cy="133.16" r="1.47642" fill={shadowColour} />
      <circle cx="144.447" cy="136.113" r="1.47642" fill={shadowColour} />
      <circle cx="263.449" cy="136.16" r="1.47642" fill={shadowColour} />
      <circle cx="156.281" cy="149.424" r="1.5" fill={shadowColour} />
      <circle cx="223.198" cy="186.31" r="1.47642" fill={shadowColour} />
      <circle cx="166.593" cy="167.117" r="1.47642" fill={shadowColour} />
      <rect x="49.1255" y="123.379" width="2" height="2.95283" fill={shadowColour} />
      <rect x="73.7632" y="123.379" width="2" height="2.95283" fill={shadowColour} />
      <rect x="26.8872" y="121.561" width="2" height="5.69392" fill={shadowColour} />
      <rect x="39.0671" y="116.918" width="2" height="10.3349" fill={shadowColour} />
      <rect x="43.009" y="120.625" width="2" height="6.62913" fill={shadowColour} />
      <rect x="70.5845" y="115.996" width="2" height="10.3349" fill={shadowColour} />
      <rect x="77.4844" y="120.625" width="2" height="5.70637" fill={shadowColour} />
      <rect x="23.1882" y="118.395" width="2" height="8.85849" fill={shadowColour} />
      <rect x="7.30908" y="121.885" width="2" height="5.04279" fill={shadowColour} />
      <rect x="30.5862" y="122.75" width="2" height="4.59375" fill={shadowColour} />
      <rect x="309.242" y="119.607" width="2" height="6.99586" fill={shadowColour} />
      <rect x="306.437" y="122.219" width="2" height="4.76076" fill={shadowColour} />
      <circle cx="168.188" cy="206.16" r="1.47642" fill={shadowColour} />
      <rect
        x="200.178"
        y="118.119"
        width="1.65534"
        height="8.55388"
        fill={shadowColour}
      />
      <rect
        x="178.572"
        y="121.561"
        width="1.65534"
        height="5.11396"
        fill={shadowColour}
      />
      <rect x="148.762" y="117.74" width="1.65534" height="8.66995" fill={shadowColour} />
      <rect x="186.567" y="124.23" width="1.65534" height="2.82257" fill={shadowColour} />
      <rect
        x="156.757"
        y="122.268"
        width="1.65534"
        height="4.78524"
        fill={shadowColour}
      />
      <rect x="254.46" y="118.119" width="1.65534" height="8.55388" fill={shadowColour} />
      <rect
        x="251.677"
        y="120.053"
        width="1.65534"
        height="6.62135"
        fill={shadowColour}
      />
      <rect x="196.66" y="122.316" width="1.65534" height="4.35669" fill={shadowColour} />
      <rect
        x="175.054"
        y="124.068"
        width="1.65534"
        height="2.60466"
        fill={shadowColour}
      />
      <rect
        x="145.245"
        y="121.994"
        width="1.65534"
        height="4.41581"
        fill={shadowColour}
      />
      <rect
        x="183.049"
        y="124.447"
        width="1.65534"
        height="2.60466"
        fill={shadowColour}
      />
      <rect x="204.225" y="124.23" width="1.65534" height="2.44397" fill={shadowColour} />
      <rect x="258.508" y="124.23" width="1.65534" height="2.44397" fill={shadowColour} />
      <rect x="120.572" y="100.033" width="2" height="26.2987" fill={shadowColour} />
      <rect x="123.986" y="105.66" width="2" height="20.6698" fill={shadowColour} />
      <rect x="133.859" y="117.473" width="2" height="8.85849" fill={shadowColour} />
      <circle
        cx="121.586"
        cy="96.5406"
        r="3.42925"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <circle
        cx="124.986"
        cy="102.83"
        r="3.15242"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <circle
        cx="134.859"
        cy="113.967"
        r="3.15242"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <rect
        x="144.194"
        y="83.9141"
        width="3.85962"
        height="2.87496"
        rx="1.43748"
        fill={shadowColour}
      />
      <rect
        x="120.126"
        y="68.4688"
        width="3.85968"
        height="2.875"
        rx="1.4375"
        fill={shadowColour}
      />
      <rect
        x="115.297"
        y="73.3438"
        width="3.85968"
        height="2.875"
        rx="1.4375"
        fill={shadowColour}
      />
      <rect x="89.5359" y="91.8145" width="2" height="14.8734" fill={shadowColour} />
      <path
        d="M87.4757 95.6442C89.1697 96.1272 90.0354 98.2215 90.2286 100.012C90.2569 100.274 88.4829 103.537 85.2349 101.701C83.9152 100.955 83.0273 100.105 81.704 98.7533C80.895 97.9272 79.2457 97.2356 79.2457 97.2356C81.9845 95.8963 84.6836 94.848 87.4757 95.6442Z"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <path
        d="M94.5518 97.4606C92.8577 97.9436 91.992 100.038 91.7988 101.828C91.7706 102.09 93.5445 105.353 96.7925 103.517C98.1123 102.771 99.0002 101.921 100.323 100.57C101.132 99.7437 102.782 99.052 102.782 99.052C100.043 97.7127 97.3439 96.6645 94.5518 97.4606Z"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <path
        d="M85.1803 126.074L80.5128 107.404H104.527L99.8593 126.074H85.1803Z"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <path d="M82.2443 112.311H102.795V114.311H82.2443V112.311Z" fill={shadowColour} />
      <path
        d="M90.0086 72.1191C91.4188 72.1191 91.6235 75.3488 91.6235 75.3488H88.3938C88.3938 75.3488 88.5985 72.1191 90.0086 72.1191Z"
        fill={shadowColour}
      />
      <path
        d="M90.0086 94.7266C91.4188 94.7266 91.6235 91.4969 91.6235 91.4969H88.3938C88.3938 91.4969 88.5985 94.7266 90.0086 94.7266Z"
        fill={shadowColour}
      />
      <path
        d="M100.927 80.4973C101.292 81.8594 98.2256 82.893 98.2256 82.893L97.3897 79.7734C97.3897 79.7734 100.562 79.1352 100.927 80.4973Z"
        fill={shadowColour}
      />
      <path
        d="M79.0901 86.3489C79.455 87.711 82.6276 87.0728 82.6276 87.0728L81.7917 83.9532C81.7917 83.9532 78.7251 84.9868 79.0901 86.3489Z"
        fill={shadowColour}
      />
      <path
        d="M100.927 80.4973C101.292 81.8594 98.2256 82.893 98.2256 82.893L97.3897 79.7734C97.3897 79.7734 100.562 79.1352 100.927 80.4973Z"
        fill={shadowColour}
      />
      <path
        d="M79.0901 86.3489C79.455 87.711 82.6276 87.0728 82.6276 87.0728L81.7917 83.9532C81.7917 83.9532 78.7251 84.9868 79.0901 86.3489Z"
        fill={shadowColour}
      />
      <path
        d="M95.6606 93.2117C94.4394 93.9168 92.6473 91.2222 92.6473 91.2222L95.4443 89.6073C95.4443 89.6073 96.8818 92.5066 95.6606 93.2117Z"
        fill={shadowColour}
      />
      <path
        d="M84.3568 73.6336C83.1356 74.3387 84.5731 77.238 84.5731 77.238L87.3701 75.6231C87.3701 75.6231 85.578 72.9285 84.3568 73.6336Z"
        fill={shadowColour}
      />
      <path
        d="M99.7979 77.7715C100.503 78.9927 97.8083 80.7848 97.8083 80.7848L96.1935 77.9879C96.1935 77.9879 99.0928 76.5503 99.7979 77.7715Z"
        fill={shadowColour}
      />
      <path
        d="M80.2192 89.0762C80.9242 90.2974 83.8235 88.8599 83.8235 88.8599L82.2087 86.0629C82.2087 86.0629 79.5141 87.855 80.2192 89.0762Z"
        fill={shadowColour}
      />
      <path
        d="M98.0016 91.4153C97.0045 92.4124 94.576 90.2734 94.576 90.2734L96.8597 87.9897C96.8597 87.9897 98.9987 90.4182 98.0016 91.4153Z"
        fill={shadowColour}
      />
      <path
        d="M82.0156 75.429C81.0185 76.4261 83.1575 78.8545 83.1575 78.8545L85.4412 76.5708C85.4412 76.5708 83.0127 74.4319 82.0156 75.429Z"
        fill={shadowColour}
      />
      <path
        d="M98.0016 75.429C98.9987 76.4261 96.8597 78.8545 96.8597 78.8545L94.576 76.5708C94.576 76.5708 97.0045 74.4319 98.0016 75.429Z"
        fill={shadowColour}
      />
      <path
        d="M82.0156 91.4153C83.0127 92.4124 85.4412 90.2734 85.4412 90.2734L83.1575 87.9897C83.1575 87.9897 81.0185 90.4182 82.0156 91.4153Z"
        fill={shadowColour}
      />
      <path
        d="M99.7981 89.0743C99.093 90.2955 96.1937 88.8579 96.1937 88.8579L97.8085 86.061C97.8085 86.061 100.503 87.8531 99.7981 89.0743Z"
        fill={shadowColour}
      />
      <path
        d="M80.2193 77.7696C79.5143 78.9908 82.2089 80.7829 82.2089 80.7829L83.8237 77.9859C83.8237 77.9859 80.9244 76.5484 80.2193 77.7696Z"
        fill={shadowColour}
      />
      <path
        d="M95.6606 73.6336C96.8818 74.3387 95.4442 77.238 95.4442 77.238L92.6473 75.6231C92.6473 75.6231 94.4394 72.9285 95.6606 73.6336Z"
        fill={shadowColour}
      />
      <path
        d="M84.3567 93.2117C85.5779 93.9168 87.37 91.2222 87.37 91.2222L84.5731 89.6073C84.5731 89.6073 83.1355 92.5066 84.3567 93.2117Z"
        fill={shadowColour}
      />
      <path
        d="M100.927 86.3489C100.562 87.711 97.3897 87.0728 97.3897 87.0728L98.2256 83.9532C98.2256 83.9532 101.292 84.9868 100.927 86.3489Z"
        fill={shadowColour}
      />
      <path
        d="M79.09 80.4973C78.725 81.8594 81.7916 82.893 81.7916 82.893L82.6275 79.7734C82.6275 79.7734 79.455 79.1352 79.09 80.4973Z"
        fill={shadowColour}
      />
      <path
        d="M92.9342 72.5039C94.2963 72.8689 93.6581 76.0414 93.6581 76.0414L90.5385 75.2055C90.5385 75.2055 91.5721 72.1389 92.9342 72.5039Z"
        fill={shadowColour}
      />
      <path
        d="M87.0829 94.3418C88.445 94.7067 89.4786 91.6401 89.4786 91.6401L86.359 90.8042C86.359 90.8042 85.7208 93.9768 87.0829 94.3418Z"
        fill={shadowColour}
      />
      <path
        d="M101.313 83.4234C101.313 84.8336 98.0828 85.0383 98.0828 85.0383L98.0828 81.8086C98.0828 81.8086 101.313 82.0133 101.313 83.4234Z"
        fill={shadowColour}
      />
      <path
        d="M78.7048 83.4234C78.7048 84.8336 81.9345 85.0383 81.9345 85.0383L81.9345 81.8086C81.9345 81.8086 78.7048 82.0133 78.7048 83.4234Z"
        fill={shadowColour}
      />
      <path
        d="M101.312 83.4234C101.312 84.8336 98.0827 85.0383 98.0827 85.0383L98.0827 81.8086C98.0827 81.8086 101.312 82.0133 101.312 83.4234Z"
        fill={shadowColour}
      />
      <path
        d="M78.7048 83.4234C78.7048 84.8336 81.9345 85.0383 81.9345 85.0383L81.9345 81.8086C81.9345 81.8086 78.7048 82.0133 78.7048 83.4234Z"
        fill={shadowColour}
      />
      <path
        d="M92.9342 94.3418C91.5721 94.7067 90.5385 91.6401 90.5385 91.6401L93.6581 90.8042C93.6581 90.8042 94.2963 93.9768 92.9342 94.3418Z"
        fill={shadowColour}
      />
      <path
        d="M87.0829 72.5039C85.7208 72.8689 86.359 76.0414 86.359 76.0414L89.4786 75.2055C89.4786 75.2055 88.445 72.1389 87.0829 72.5039Z"
        fill={shadowColour}
      />
      <circle
        cx="90.0086"
        cy="83.4234"
        r="5.8511"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <rect x="54.344" y="93.3867" width="2" height="13.2877" fill={shadowColour} />
      <rect x="58.7732" y="99.291" width="2" height="7.38208" fill={shadowColour} />
      <path
        d="M58.0871 87.4215C56.0867 89.1423 56.1616 92.6103 56.9638 95.2374C57.0812 95.622 61.4141 99.101 64.7091 94.5269C66.0479 92.6683 66.7417 90.9298 67.7259 88.2208C68.3276 86.5649 70.1437 84.5793 70.1437 84.5793C65.6506 84.3906 61.384 84.5853 58.0871 87.4215Z"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <path
        d="M52.2528 89.9254C53.9468 90.4084 54.8125 92.5028 55.0057 94.2928C55.034 94.5548 53.26 97.8181 50.012 95.9821C48.6923 95.2361 47.8044 94.3859 46.4811 93.0345C45.6721 92.2085 44.0228 91.5168 44.0228 91.5168C46.7616 90.1775 49.4607 89.1293 52.2528 89.9254Z"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <path
        d="M49.9573 126.344L45.2898 107.674H69.3037L64.6363 126.344H49.9573Z"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <path d="M46.3323 112.58H68.2615V114.58H46.3323V112.58Z" fill={shadowColour} />
      <rect
        x="214.789"
        y="88.6602"
        width="32.7621"
        height="37.7281"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <rect x="191.442" y="102.533" width="23.1747" height="2" fill={shadowColour} />
      <rect x="198.886" y="106.686" width="15.73" height="2.02923" fill={shadowColour} />
      <rect x="215.002" y="96.0391" width="31.8932" height="2" fill={shadowColour} />
      <rect x="215.002" y="99.0039" width="31.8932" height="2" fill={shadowColour} />
      <rect
        x="174.609"
        y="93.2572"
        width="45.8683"
        height="1"
        transform="rotate(30 174.609 93.2572)"
        fill={shadowColour}
        stroke={shadowColour}
      />
      <rect
        x="172.426"
        y="96.0391"
        width="49.6902"
        height="2"
        transform="rotate(30 172.426 96.0391)"
        fill={shadowColour}
      />
      <path
        d="M170.493 97.3871L165.101 96.9235L170.529 87.5224L173.626 91.9602L170.493 97.3871Z"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <rect
        x="227.67"
        y="73.0586"
        width="7"
        height="15"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <mask id="path-132-inside-1" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M246.895 121.282L247.174 121.56L260.945 107.79L260.959 107.776L260.973 107.762L261.353 107.382L261.342 107.371C264.87 103.434 264.742 97.3799 260.959 93.5967C257.176 89.8135 251.121 89.6858 247.185 93.2136L247.174 93.2028L247.163 93.2136C247.075 93.1345 246.986 93.0573 246.895 92.9819V121.282Z"
        />
      </mask>
      <path
        d="M247.174 121.56L246.003 122.731L247.174 123.901L248.344 122.731L247.174 121.56ZM246.895 121.282H245.24V121.968L245.725 122.452L246.895 121.282ZM260.945 107.79L259.775 106.618L259.774 106.619L260.945 107.79ZM260.959 107.776L262.128 108.947L262.13 108.945L260.959 107.776ZM260.973 107.762L259.802 106.591L259.801 106.592L260.973 107.762ZM261.353 107.382L262.523 108.552L263.694 107.382L262.523 106.211L261.353 107.382ZM261.342 107.371L260.109 106.266L259.063 107.433L260.171 108.541L261.342 107.371ZM260.959 93.5967L259.788 94.7672V94.7672L260.959 93.5967ZM247.185 93.2136L246.014 94.384L247.122 95.4922L248.289 94.4463L247.185 93.2136ZM247.174 93.2028L248.344 92.0323L247.174 90.8618L246.003 92.0323L247.174 93.2028ZM247.163 93.2136L246.058 94.4463L247.225 95.4922L248.334 94.384L247.163 93.2136ZM246.895 92.9819L247.956 91.7113L245.24 89.4435V92.9819H246.895ZM248.344 120.39L248.066 120.111L245.725 122.452L246.003 122.731L248.344 120.39ZM259.774 106.619L246.003 120.39L248.344 122.731L262.115 108.96L259.774 106.619ZM259.789 106.604L259.775 106.618L262.114 108.961L262.128 108.947L259.789 106.604ZM259.801 106.592L259.787 106.606L262.13 108.945L262.144 108.931L259.801 106.592ZM260.182 106.211L259.802 106.591L262.143 108.932L262.523 108.552L260.182 106.211ZM260.171 108.541L260.182 108.552L262.523 106.211L262.512 106.2L260.171 108.541ZM259.788 94.7672C262.947 97.9254 263.054 102.981 260.109 106.266L262.575 108.476C266.686 103.888 266.538 96.8344 262.129 92.4262L259.788 94.7672ZM248.289 94.4463C251.575 91.5019 256.63 91.609 259.788 94.7672L262.129 92.4262C257.721 88.018 250.667 87.8696 246.08 91.9808L248.289 94.4463ZM246.003 94.3733L246.014 94.384L248.355 92.0431L248.344 92.0323L246.003 94.3733ZM248.334 94.384L248.344 94.3733L246.003 92.0323L245.993 92.0431L248.334 94.384ZM245.834 94.2526C245.91 94.3156 245.985 94.3802 246.058 94.4463L248.268 91.9808C248.165 91.8889 248.061 91.799 247.956 91.7113L245.834 94.2526ZM245.24 92.9819V121.282H248.551V92.9819H245.24Z"
        fill={shadowColour}
        mask="url(#path-132-inside-1)"
      />
      <path
        d="M165.865 108.796C165.865 110.13 164.783 111.212 163.449 111.212C162.114 111.212 161.032 110.13 161.032 108.796C161.032 107.461 163.449 103.963 163.449 103.963C163.449 103.963 165.865 107.461 165.865 108.796Z"
        fill={shadowColour}
      />
      <path
        d="M207.739 71.5395C208.153 72.0517 208.625 72.3976 208.113 72.8116C207.601 73.2256 206.298 73.5509 205.884 73.0387C205.47 72.5265 205.55 71.7757 206.062 71.3617C206.574 70.9477 207.325 71.0273 207.739 71.5395Z"
        fill={shadowColour}
      />
      <path
        d="M209.278 73.4445C208.864 72.9323 208.625 72.3984 208.113 72.8124C207.601 73.2264 207.009 74.4315 207.423 74.9437C207.837 75.4559 208.588 75.5355 209.1 75.1215C209.613 74.7075 209.692 73.9566 209.278 73.4445Z"
        fill={shadowColour}
      />
      <path
        d="M207.762 71.5204C208.176 72.0326 208.415 72.5664 208.927 72.1524C209.44 71.7384 210.031 70.5333 209.617 70.0211C209.203 69.509 208.452 69.4294 207.94 69.8434C207.427 70.2574 207.348 71.0082 207.762 71.5204Z"
        fill={shadowColour}
      />
      <path
        d="M209.301 73.4254C208.887 72.9132 208.415 72.5673 208.927 72.1533C209.44 71.7393 210.742 71.4139 211.156 71.9261C211.57 72.4383 211.49 73.1891 210.978 73.6031C210.466 74.0171 209.715 73.9375 209.301 73.4254Z"
        fill={shadowColour}
      />
      <path
        d="M200.804 84.6157C201.218 85.1278 201.69 85.4737 201.178 85.8877C200.665 86.3018 199.363 86.6271 198.949 86.1149C198.535 85.6027 198.615 84.8519 199.127 84.4379C199.639 84.0239 200.39 84.1035 200.804 84.6157Z"
        fill={shadowColour}
      />
      <path
        d="M202.343 86.5206C201.929 86.0085 201.69 85.4746 201.178 85.8886C200.665 86.3026 200.074 87.5077 200.488 88.0199C200.902 88.5321 201.653 88.6117 202.165 88.1976C202.677 87.7836 202.757 87.0328 202.343 86.5206Z"
        fill={shadowColour}
      />
      <path
        d="M200.827 84.5966C201.241 85.1087 201.48 85.6426 201.992 85.2286C202.504 84.8146 203.096 83.6095 202.682 83.0973C202.268 82.5851 201.517 82.5055 201.004 82.9195C200.492 83.3335 200.413 84.0844 200.827 84.5966Z"
        fill={shadowColour}
      />
      <path
        d="M202.366 86.5015C201.952 85.9893 201.48 85.6434 201.992 85.2294C202.504 84.8154 203.807 84.4901 204.221 85.0023C204.635 85.5145 204.555 86.2653 204.043 86.6793C203.531 87.0933 202.78 87.0137 202.366 86.5015Z"
        fill={shadowColour}
      />
      <circle
        cx="77.8212"
        cy="29.1423"
        r="15.6774"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <rect
        x="70.3674"
        y="4.68359"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(-15 70.3674 4.68359)"
        fill={shadowColour}
      />
      <rect
        x="82.3121"
        y="49.2617"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(-15 82.3121 49.2617)"
        fill={shadowColour}
      />
      <rect
        x="91.3973"
        y="51.1855"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(150 91.3973 51.1855)"
        fill={shadowColour}
      />
      <rect
        x="68.3218"
        y="11.2168"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(150 68.3218 11.2168)"
        fill={shadowColour}
      />
      <rect
        x="100.511"
        y="41.4668"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(120 100.511 41.4668)"
        fill={shadowColour}
      />
      <rect
        x="60.5437"
        y="18.3906"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(120 60.5437 18.3906)"
        fill={shadowColour}
      />
      <rect
        x="102.883"
        y="35.1816"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(105 102.883 35.1816)"
        fill={shadowColour}
      />
      <rect
        x="58.3044"
        y="23.2363"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(105 58.3044 23.2363)"
        fill={shadowColour}
      />
      <rect
        x="102.456"
        y="21.8652"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(75 102.456 21.8652)"
        fill={shadowColour}
      />
      <rect
        x="57.8777"
        y="33.8105"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(75 57.8777 33.8105)"
        fill={shadowColour}
      />
      <rect
        x="99.6874"
        y="15.7422"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(60 99.6874 15.7422)"
        fill={shadowColour}
      />
      <rect
        x="59.7195"
        y="38.8184"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(60 59.7195 38.8184)"
        fill={shadowColour}
      />
      <rect
        x="89.9698"
        y="6.62891"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(30 89.9698 6.62891)"
        fill={shadowColour}
      />
      <rect
        x="66.8943"
        y="46.5977"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(30 66.8943 46.5977)"
        fill={shadowColour}
      />
      <rect
        x="83.6833"
        y="4.25781"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(15 83.6833 4.25781)"
        fill={shadowColour}
      />
      <rect
        x="71.7385"
        y="48.8359"
        width="1.64825"
        height="5.29793"
        rx="0.824123"
        transform="rotate(15 71.7385 48.8359)"
        fill={shadowColour}
      />
      <rect
        x="76.9971"
        y="0.298828"
        width="1.64825"
        height="8.24123"
        rx="0.824123"
        fill={shadowColour}
      />
      <rect
        x="76.9971"
        y="49.7461"
        width="1.64825"
        height="8.24123"
        rx="0.824123"
        fill={shadowColour}
      />
      <rect
        x="98.8"
        y="48.957"
        width="1.64825"
        height="8.24123"
        rx="0.824123"
        transform="rotate(135 98.8 48.957)"
        fill={shadowColour}
      />
      <rect
        x="63.8354"
        y="13.9922"
        width="1.64825"
        height="8.24123"
        rx="0.824123"
        transform="rotate(135 63.8354 13.9922)"
        fill={shadowColour}
      />
      <rect
        x="97.6346"
        y="8.16406"
        width="1.64825"
        height="8.24123"
        rx="0.824123"
        transform="rotate(45 97.6346 8.16406)"
        fill={shadowColour}
      />
      <rect
        x="62.6702"
        y="43.1289"
        width="1.64825"
        height="8.24123"
        rx="0.824123"
        transform="rotate(45 62.6702 43.1289)"
        fill={shadowColour}
      />
      <rect
        x="106.666"
        y="28.3184"
        width="1.64825"
        height="8.24123"
        rx="0.824123"
        transform="rotate(90 106.666 28.3184)"
        fill={shadowColour}
      />
      <rect
        x="57.2183"
        y="28.3184"
        width="1.64825"
        height="8.24123"
        rx="0.824123"
        transform="rotate(90 57.2183 28.3184)"
        fill={shadowColour}
      />
      <rect
        width="2"
        height="7.09184"
        rx="1"
        transform="matrix(-0.474088 0.880477 0.880477 0.474088 170.211 41.3145)"
        fill={shadowColour}
      />
      <rect
        x="170.687"
        y="41.3145"
        width="2"
        height="7.09184"
        rx="1"
        transform="rotate(61.7 170.687 41.3145)"
        fill={shadowColour}
      />
      <rect
        width="2"
        height="7.09184"
        rx="1"
        transform="matrix(-0.474088 0.880477 0.880477 0.474088 184.352 46.8125)"
        fill={shadowColour}
      />
      <rect
        x="184.829"
        y="46.8125"
        width="2"
        height="7.09184"
        rx="1"
        transform="rotate(61.7 184.829 46.8125)"
        fill={shadowColour}
      />
      <mask id="path-172-inside-2" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M214.022 18.168C217.165 18.168 219.723 20.4957 219.806 23.3963C220.844 22.7295 222.084 22.3421 223.415 22.3421C227.072 22.3421 230.036 25.2646 230.036 28.8697C230.036 29.0974 230.024 29.3224 230.001 29.5441C230.587 29.387 231.203 29.3031 231.84 29.3031C235.677 29.3031 238.789 32.3537 238.789 36.1168C238.789 39.8799 235.677 42.9306 231.84 42.9306C231.836 42.9306 231.832 42.9306 231.828 42.9306H197.712V42.9112C197.556 42.924 197.397 42.9305 197.238 42.9305C194.121 42.9305 191.595 40.4537 191.595 37.3983C191.595 34.6957 193.572 32.4458 196.185 31.9623C196.288 27.3251 200.079 23.5977 204.741 23.5977C206.013 23.5977 207.22 23.8751 208.305 24.3725C208.259 24.1016 208.236 23.824 208.236 23.5413C208.236 20.5737 210.826 18.168 214.022 18.168Z"
        />
      </mask>
      <path
        d="M219.806 23.3963L217.807 23.4533L217.908 26.9925L220.887 25.0791L219.806 23.3963ZM230.001 29.5441L228.012 29.337L227.711 32.2295L230.519 31.4758L230.001 29.5441ZM231.828 42.9306L231.831 40.9306H231.828V42.9306ZM197.712 42.9306H195.712V44.9306H197.712V42.9306ZM197.712 42.9112H199.712V40.7413L197.549 40.9179L197.712 42.9112ZM196.185 31.9623L196.549 33.9289L198.148 33.6329L198.184 32.0068L196.185 31.9623ZM208.305 24.3725L207.471 26.1905L210.899 27.7625L210.277 24.0426L208.305 24.3725ZM221.805 23.3393C221.688 19.2285 218.115 16.168 214.022 16.168V20.168C216.216 20.168 217.759 21.7629 217.807 23.4533L221.805 23.3393ZM223.415 20.3421C221.691 20.3421 220.077 20.845 218.725 21.7135L220.887 25.0791C221.611 24.6141 222.477 24.3421 223.415 24.3421V20.3421ZM232.036 28.8697C232.036 24.1334 228.149 20.3421 223.415 20.3421V24.3421C225.994 24.3421 228.036 26.3958 228.036 28.8697H232.036ZM231.99 29.7512C232.02 29.4608 232.036 29.1667 232.036 28.8697H228.036C228.036 29.0281 228.028 29.184 228.012 29.337L231.99 29.7512ZM231.84 27.3031C231.027 27.3031 230.236 27.4103 229.483 27.6125L230.519 31.4758C230.937 31.3637 231.38 31.3031 231.84 31.3031V27.3031ZM240.789 36.1168C240.789 31.2122 236.745 27.3031 231.84 27.3031V31.3031C234.61 31.3031 236.789 33.4952 236.789 36.1168H240.789ZM231.84 44.9306C236.745 44.9306 240.789 41.0214 240.789 36.1168H236.789C236.789 38.7385 234.61 40.9306 231.84 40.9306V44.9306ZM231.825 44.9305C231.829 44.9306 231.834 44.9306 231.84 44.9306V40.9306C231.837 40.9306 231.834 40.9306 231.831 40.9306L231.825 44.9305ZM231.828 40.9306H197.712V44.9306H231.828V40.9306ZM199.712 42.9306V42.9112H195.712V42.9306H199.712ZM197.238 44.9305C197.452 44.9305 197.664 44.9218 197.875 44.9046L197.549 40.9179C197.447 40.9262 197.343 40.9305 197.238 40.9305V44.9305ZM189.595 37.3983C189.595 41.5951 193.054 44.9305 197.238 44.9305V40.9305C195.189 40.9305 193.595 39.3122 193.595 37.3983H189.595ZM195.821 29.9956C192.305 30.6463 189.595 33.6866 189.595 37.3983H193.595C193.595 35.7048 194.839 34.2452 196.549 33.9289L195.821 29.9956ZM204.741 21.5977C198.99 21.5977 194.313 26.1961 194.185 31.9178L198.184 32.0068C198.263 28.4541 201.169 25.5977 204.741 25.5977V21.5977ZM209.138 22.5545C207.797 21.9396 206.306 21.5977 204.741 21.5977V25.5977C205.719 25.5977 206.642 25.8106 207.471 26.1905L209.138 22.5545ZM206.236 23.5413C206.236 23.9351 206.269 24.3231 206.332 24.7024L210.277 24.0426C210.25 23.8801 210.236 23.7129 210.236 23.5413H206.236ZM214.022 16.168C209.864 16.168 206.236 19.3323 206.236 23.5413H210.236C210.236 21.8151 211.789 20.168 214.022 20.168V16.168Z"
        fill={shadowColour}
        mask="url(#path-172-inside-2)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M198.142 26.7068C197.47 26.3394 196.7 26.1304 195.88 26.1304C195.808 26.1304 195.736 26.1321 195.665 26.1352L194.253 26.1982L193.722 24.8877C192.869 22.78 190.804 21.2991 188.398 21.2991C188.356 21.2991 188.314 21.2996 188.272 21.3005L187.125 21.325L186.525 20.3484C185.112 18.0505 182.58 16.5254 179.694 16.5254C175.918 16.5254 172.747 19.1396 171.903 22.6593L171.447 24.5597L169.537 24.1478C169.144 24.0631 168.734 24.0181 168.312 24.0181C165.123 24.0181 162.539 26.6029 162.539 29.7914C162.539 32.8924 164.984 35.4232 168.051 35.559L168.18 35.5648H168.29H168.296L168.312 35.5648L168.328 35.5648L168.334 35.5648L191.913 35.5648C191.707 36.1387 191.595 36.7559 191.595 37.3987C191.595 37.4543 191.596 37.5096 191.598 37.5648H169.962H168.334L168.312 37.5648L168.29 37.5648H167.962V37.5571C163.831 37.3741 160.539 33.9673 160.539 29.7914C160.539 25.4983 164.019 22.0181 168.312 22.0181C168.877 22.0181 169.428 22.0783 169.958 22.1927C171.013 17.7944 174.972 14.5254 179.694 14.5254C183.304 14.5254 186.467 16.4359 188.229 19.3009C188.285 19.2997 188.341 19.2991 188.398 19.2991C191.646 19.2991 194.428 21.3003 195.576 24.1372C195.677 24.1327 195.778 24.1304 195.88 24.1304C197.274 24.1304 198.569 24.5551 199.643 25.282C199.087 25.695 198.583 26.1737 198.142 26.7068Z"
        fill={shadowColour}
      />
      <path
        d="M276.309 29.8445V23.6523H260.309V29.8445"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <path
        d="M265.976 43.2938L260.807 30.8438H275.811L270.641 43.2938H265.976Z"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <rect
        x="266.309"
        y="45.2949"
        width="4"
        height="28.3594"
        stroke={shadowColour}
        strokeWidth="2"
      />
      <mask
        id="mask0"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="257"
        y="72"
        width="22"
        height="56"
      >
        <rect x="257.934" y="72.6602" width="20.75" height="54.7281" fill="#FF5ADB" />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M265.309 99.6172H259.934H257.934V101.617V120.449C257.934 124.913 264.451 130.617 268.309 130.617C272.167 130.617 278.684 124.913 278.684 120.449V101.617V99.6172H276.684H271.309V99.6592L270.834 101.617H276.684V120.449C276.684 121.097 276.439 121.942 275.873 122.921C275.317 123.884 274.514 124.866 273.574 125.75C272.634 126.633 271.604 127.374 270.629 127.885C269.626 128.411 268.825 128.617 268.309 128.617C267.793 128.617 266.992 128.411 265.988 127.885C265.014 127.374 263.984 126.633 263.044 125.75C262.103 124.866 261.301 123.884 260.744 122.921C260.179 121.942 259.934 121.097 259.934 120.449V101.617H265.783L265.309 99.6592V99.6172Z"
          fill={shadowColour}
        />
        <path
          d="M266.309 99.5407V73.6602H270.309V99.5407L268.309 107.795L266.309 99.5407Z"
          stroke={shadowColour}
          strokeWidth="2"
        />
      </g>
    </svg>
  );
});
